import BaseComponent from '../BaseComponent'
import React from 'react'
import firebase from 'firebase'

export default class SignInComponent extends BaseComponent {
	constructor(props) {
		super()
	}

	componentDidMount() {
		const that = this
		const uiConfig = {
			callbacks: {
				signInSuccess(user) {
					if (that.props.onSignIn) {
						that.props.onSignIn(user)
					}
					return false
				}
			},
			signInOptions: [
				firebase.auth.EmailAuthProvider.PROVIDER_ID,
				firebase.auth.GoogleAuthProvider.PROVIDER_ID,
				firebase.auth.FacebookAuthProvider.PROVIDER_ID,
				firebase.auth.TwitterAuthProvider.PROVIDER_ID
			]
		}
		this.props.authUi.start('#firebaseui-auth', uiConfig)
	}

	componentWillUnmount() {
		this.props.authUi.reset()
	}

	render() {
		return (
			<div>
				<div id="firebaseui-auth" />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/SignIn.js